import React from "react";
import "../styles/CookieBanner.css";

const CookieBanner = ({ isVisible, onClose }) => {
  if (!isVisible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-text">
          <span className="cookie-icon">🍪</span>
          <p>
            We use cookies to enhance your experience. By continuing to visit
            this site you agree to our use of cookies.
          </p>
        </div>
        <div className="cookie-banner-buttons">
          <button className="accept-button" onClick={onClose}>
            Accept
          </button>
          <button className="decline-button" onClick={onClose}>
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
